import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    background: "gainsboro",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function ConfirmationModal(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  //   setOpen(props.open);
  React.useEffect(() => setOpen(props.open));
  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2 id="simple-modal-title" style={{ marginBottom: "40px" }}>
          {props.message}
        </h2>

        <Button
          variant="contained"
          onClick={() => props.handleClose()}
          color="secondary"
        >
          No
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            props.handleClose();
            props.onConfirm();
          }}
          color="primary"
          style={{ marginLeft: "20px" }}
        >
          Yes
        </Button>
        {/* <SimpleModal /> */}
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={props.handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
